import { Outlet, createFileRoute } from '@tanstack/react-router';

/** Layout for `/profile/bonuses` and `/profile/bonuses/$bonusType/$bonusId`. */
export const Route = createFileRoute('/profile/bonuses')({
  component: ProfileBonusesLayout,
});

function ProfileBonusesLayout() {
  return <Outlet />;
}
